// extracted by mini-css-extract-plugin
module.exports = {"MobileTable":"MobileTable_MobileTable__mQyDB"};